import { render, staticRenderFns } from "./MilestoneCreate.vue?vue&type=template&id=4a34835b&"
import script from "./MilestoneCreate.vue?vue&type=script&lang=js&"
export * from "./MilestoneCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports